import { defineTransform } from "../transform";

defineTransform("create_object", "create_object", (op1, op2, side) => {
  // See if both are creating the same object, if so, the second operation
  // is redundant.
  if (op2.p[0] === op1.p[0] && op2.p[1] === op1.p[1]) {
    return;
  }

  return op1;
});

// We always create the object, even if we just deleted the same object.
defineTransform("create_object", "delete_object", (op1, op2, side) => op1);
defineTransform("create_object", "update_property", (op1, op2, side) => op1);

defineTransform("create_object", "stack_create", (op1, op2, side) => op1);
defineTransform("create_object", "stack_delete", (op1, op2, side) => op1);
